import { AzureDataLakeStoreFileDataset } from './../../dataset/azure-data-lake-store.dataset';
import { FileTypeCopySink } from './file-type.copysink';
import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.azureDataLakeStore.copySinkType,
    display: [],
    referable: true,
    tags: { datasetModel: Metamodel.modelFor(AzureDataLakeStoreFileDataset) }
})
export class AzureDataLakeStoreSink extends FileTypeCopySink {
    public static readonly MODEL: IModel;
}
